import React from 'react';
import { Button, Modal, useModalContext } from '@ally/metronome-ui';
import { HowToSetUpPushApproveContent } from '.';
const ModalTrigger = () => {
    const { setOpen } = useModalContext();
    return (React.createElement(Button, { variant: "link", text: "Set it up for future logins", onClick: () => setOpen(true) }));
};
export const HowToSetUpPushApproveModal = ({ showTrigger = true, }) => (React.createElement(Modal, Object.assign({ content: React.createElement(HowToSetUpPushApproveContent, null) }, (showTrigger ? { trigger: React.createElement(ModalTrigger, null) } : {}))));
//# sourceMappingURL=HowToSetUpPushApproveModal.js.map